export default "<div [ngClass]=\"{'positive': connectedToWWE, 'negative' : !connectedToWWE}\">\r\n</div>";